import ApiClient from "@common/api/ApiClient";

class ComplianceAlertClient extends ApiClient {
  constructor() {
    super("Alert");
    this.setApiUrlKey("comp_api_url");
  }

  getMetaData = async () => await this.get("Search");

  getAlerts = async (payload) => {
    return await this.post("Search", payload);
  };

  clearAlerts = async (payload) => {
    return await this.post("Clear", payload);
  };
}

const client = new ComplianceAlertClient();

export default client;
